import { apiClient } from '@/shared/api/client';
import { ENDPOINTS } from '@/shared/api/endpoints';

import {
  type LoginInput,
  type LoginResponse,
  loginResponseSchema,
} from '../model/auth.schema';

/**
 * `POST /auth/login` no pasa por el ResponseInterceptor del backend
 * (usa @Res() res.json) — la respuesta NO está envuelta en { success, data, … }.
 * Por eso llamamos a `apiClient` directo y validamos la forma con Zod.
 */
export async function login(input: LoginInput): Promise<LoginResponse> {
  const { data } = await apiClient.post<unknown>(ENDPOINTS.auth.login, input);
  return loginResponseSchema.parse(data);
}
